import { MediumFormatting } from "@faire/web/common/localization/formatting";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

import { getVerticalizedTopBannerText } from "@faire/retailer/components/Notifications/Components/__internal__/getVerticalizedTopBannerText";
import { useFaireDirectMarketplaceIncentive } from "@faire/retailer/hooks/FaireDirect/useFaireDirectMarketplaceIncentive/useFaireDirectMarketplaceIncentive";

export const useFaireDirectMarketplaceIncentiveBannerTextContent = () => {
  const {
    formattedDiscountPercentNumber,
    daysRemaining,
    offerName,
    isFaireDirectMarketplaceIncentive,
    storeType,
  } = useFaireDirectMarketplaceIncentive();

  if (isFaireDirectMarketplaceIncentive) {
    if (daysRemaining === 2) {
      return (
        <StrictLocalMsg
          defaultMessage="<MediumFormatting>{daysRemainingNumber} days left!</MediumFormatting> Enjoy {formattedDiscountPercentNumber} off."
          description={{
            text: "Content of Faire Direct Marketplace banner highlighting the marketplace incentive when only two days are left.",
            img: "https://cdn.faire.com/fastly/64742630134bb95fd3c11bee3a4b51c2d1055ca6b36de200d77ce7e94cce3a53.png",
          }}
          values={{
            MediumFormatting,
            daysRemainingNumber: 2,
            formattedDiscountPercentNumber,
          }}
        />
      );
    }

    if (daysRemaining === 1) {
      return (
        <StrictLocalMsg
          defaultMessage="<MediumFormatting>Last day!</MediumFormatting> Enjoy {formattedDiscountPercentNumber} off."
          description={{
            text: "Content of Faire Direct Marketplace banner highlighting the marketplace incentive when it is the last day.",
            img: "https://cdn.faire.com/fastly/d4513a36c5b3b170d4be9612f35792e4f8c67ee7a80a35e5e0dbb85d98b356ac.png",
          }}
          values={{
            MediumFormatting,
            formattedDiscountPercentNumber,
          }}
        />
      );
    }
  }

  return getVerticalizedTopBannerText({
    formattedIncentivePercentNumber: formattedDiscountPercentNumber,
    offerName,
    storeType,
  });
};
